import { fetchAuthSession } from 'aws-amplify/auth';
import { addRawAnalyticsLog } from './AddRawAnalyticsLog';
import user from 'src/api/user';
import { clearCredentials, Hub } from '@aws-amplify/core';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { AMPLIFY_SYMBOL } from '@aws-amplify/core/internals/utils';

export const signOutLocally = async (): Promise<void> => {
  try {
    // clear tokens and credentials
    await cognitoUserPoolsTokenProvider.authTokenStore.clearTokens();
    await cognitoUserPoolsTokenProvider.authTokenStore.clearDeviceMetadata();
    await cognitoUserPoolsTokenProvider.tokenOrchestrator.clearDeviceMetadata();
    await cognitoUserPoolsTokenProvider.tokenOrchestrator.clearTokens();
    await clearCredentials();

    Hub.dispatch('auth', { event: 'signedOut' }, 'Auth', AMPLIFY_SYMBOL);
  } catch (error) {
    console.error('Error signing out:', error);
    throw error;
  }
};

export const signOutUser = async (global = false): Promise<void> => {
  try {
    // call api to signOut from server
    try {
      const { tokens } = await fetchAuthSession();

      if (tokens?.idToken) {
        await user.signOutUser();
      }
    } catch (error) {
      console.error('Error signing out from server:', error);
    }

    // clear tokens and credentials to signOut locally
    await signOutLocally();
  } catch (error) {
    console.error('Error signing out:', error);
    throw error;
  }
};

export const deleteAccount = async (): Promise<void> => {
  try {
    // call api to signOut from server
    await user.signOutUser();

    // delete user from server
    await user.deleteUser();
  } catch (error) {
    console.error('Error signing out:', error);
    throw error;
  }
};

export const getTokenRaw = async (): Promise<string> => {
  try {
    // Try to get current session first
    const { tokens } = await fetchAuthSession();

    if (tokens?.idToken) {
      return tokens.idToken.toString();
    }

    // In v6, the session refresh is handled automatically by Amplify
    // We just need to fetch the session again
    const refreshedSession = await fetchAuthSession({ forceRefresh: true });

    if (refreshedSession.tokens?.idToken) {
      return refreshedSession.tokens.idToken.toString();
    }

    // If we still don't have a token, sign out
    await signOutUser();
    throw new Error('Unable to get valid session');
  } catch (error) {
    addRawAnalyticsLog('Error', {
      file: 'useUser.tsx',
      function: 'getToken',
      data: error
    });

    // Sign out on error
    await signOutUser();
    throw error;
  }
};
